import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, PropsWithChildren } from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';
import { CademyIcon } from '../../Icons';

export type ClaimProfileWrapperProps = PropsWithChildren<{
    educator: PublicEducator;
}>;

export const ClaimProfileWrapper: FunctionComponent<ClaimProfileWrapperProps> = ({
    educator,
    children,
}) => {
    return (
        <section className={styles.container}>
            <div className={styles.header}>
                <div className={`rounded_image ${styles.educator_logo}`}>
                    <Image
                        src={
                            educator.logo_url
                                ? educator.logo_url
                                : `${process.env.NEXT_PUBLIC_ASSETS_URL}/images/educator_fallback_logo.svg`
                        }
                        alt={`${educator.name} logo`}
                        fill
                        priority={true}
                        sizes="110px"
                    />
                </div>
                <div className={styles.educator_info}>
                    <h3>{educator.name}</h3>
                    <a href={`${educator.links?.web}`} target="_blank" rel="noopener noreferrer">
                        {educator.links?.web}
                    </a>
                </div>
                <CademyIcon className={styles.cademy_icon} height={50} width={50} />
            </div>
            {children}
        </section>
    );
};

export default ClaimProfileWrapper;
